import React, { useEffect, useImperativeHandle, useState } from "react";
import { Form, Row, Col, Divider, Button, Space, Select, Input } from "antd";
import {
  fieldsVital,
  listMethodIntraocularPressure,
  listPunctumSyringing,
} from "./config";
import { InputFields, Notification } from "components/common";
import Icon from "assets/icons";
import "./NurseInfo.scss";
import { useAppSelector } from "redux/hooks";
import { FORMAT_TIME, tabKeys } from "types/enums";
import moment from "moment";
import {
  formatDateToString,
  getBmi,
  isValuable,
  jsonParse,
  toNumber,
} from "helper/common";
import FormList from "./FormList/FormList";
import { nurseOutService } from "api";
import { nhanAp } from "pages/ResidentialNurse/Treatment/tabs/TreatmentInfo/config";

const NurseInfo = React.forwardRef<any>((props: any, ref) => {
  const detailPhieu = useAppSelector((state) => state.nurseOut.detailPhieu);
  const [form] = Form.useForm();
  const vitalSigns = Form.useWatch("vitalSigns", form);
  useEffect(() => {}, [vitalSigns]);
  const [formValues, setFormValues] = useState<any>();
  const [fields, setFields] = useState<any[]>(fieldsVital(""));
  const [listLeDao, setListLeDaoe] = useState<any>([]);
  const [listNA, setListNA] = useState<any>([]);
  const idPhieu = useAppSelector((state) => state.nurseOut.idPhieu);
  useImperativeHandle(ref, () => ({
    getFormValue: () => {
      return form.getFieldsValue();
    },
  }));
  useEffect(() => {
    // console.log("initial");
    const setInitialValue = () => {
      var formValue = parseJsonValueToObject(detailPhieu?.jsonDieuDuongDto);
      console.log(formValue);
      if (!formValue?.intraocularPressure) {
        formValue.intraocularPressure = {
          intraocularPressureLeft: [
            {
              mmHg: "",
              min: "",
              method: "",
            },
          ],
          intraocularPressureRight: [
            {
              mmHg: "",
              min: "",
              method: "",
            },
          ],
        };
      }
      if (!formValue?.randomBloodSugar) {
        formValue.randomBloodSugar = {
          Result: [{ mmHg: "", min: "" }],
          Comment: "",
        };
      }
      if (toNumber(formValue?.vitalSigns?.Temperature?.Result?.length) == 0) {
        formValue.vitalSigns = {
          ...formValue.vitalSigns,
          Temperature: { Result: [{ value: "", min: "" }] },
        };
      }
      if (toNumber(formValue?.vitalSigns?.BloodPressure?.Result?.length) == 0) {
        formValue.vitalSigns = {
          ...formValue.vitalSigns,
          BloodPressure: { Result: [{ value: "", min: "" }] },
        };
      }
      if (toNumber(formValue?.vitalSigns?.RR?.Result?.length) == 0) {
        formValue.vitalSigns = {
          ...formValue.vitalSigns,
          RR: { Result: [{ value: "", min: "" }] },
        };
      }
      if (toNumber(formValue?.vitalSigns?.Pulse?.Result?.length) == 0) {
        formValue.vitalSigns = {
          ...formValue.vitalSigns,
          Pulse: { Result: [{ value: "", min: "" }] },
        };
      }
      if (toNumber(formValue?.vitalSigns?.Sp02?.Result?.length) == 0) {
        formValue.vitalSigns = {
          ...formValue.vitalSigns,
          Sp02: { Result: [{ value: "", min: "" }] },
        };
      }

      setFormValues({ ...formValue });
    };
    setInitialValue();

    const setChieuCaoCanNang = async () => {
      if (detailPhieu && !isValuable(detailPhieu?.jsonDieuDuongDto)) {
        const data = await getChieuCaoCanNang(detailPhieu?.id);
        const vitalSigns = jsonParse(data?.vitalSigns);
        form.setFieldValue(["vitalSigns", "Weight"], vitalSigns?.Weight);
        form.setFieldValue(["vitalSigns", "Height"], vitalSigns?.Height);
        form.setFieldValue(["vitalSigns", "BMI"], vitalSigns?.BMI);
      }
    };
    setChieuCaoCanNang();
  }, [detailPhieu]);
  const getChieuCaoCanNang = async (id) => {
    try {
      const res = await nurseOutService.getChieuCaoCanNangTienSu(id);
      return res;
    } catch (error) {
      return null;
    }
  };
  useEffect(() => {
    form.setFieldsValue(formValues);
  }, [formValues]);
  useEffect(() => {
    form.resetFields();
  }, [idPhieu]);
  const parseJsonValueToObject = (dataJson) => {
    const data = {
      ...dataJson,
      vitalSigns: jsonParse(dataJson?.vitalSigns),
      syringing: jsonParse(dataJson?.syringing),
      randomBloodSugar: jsonParse(dataJson?.randomBloodSugar),
      intraocularPressure: jsonParse(dataJson?.intraocularPressure),
    };
    return data;
  };
  const setFieldValueTime = (namePath) => {
    form.setFieldValue(
      namePath,
      formatDateToString(moment(), FORMAT_TIME.dateTime)
    );
  };
  useEffect(() => {
    fields.find((e) => e.label == "Chiều cao").onChange = (e) => {
      const chieuCao = e;
      const canNang = form.getFieldValue(["vitalSigns", "Weight"]);
      const bmi = getBmi(chieuCao, canNang);
      form.setFieldValue(["vitalSigns", "BMI"], bmi);
    };

    fields.find((e) => e.label == "Cân nặng").onChange = (e) => {
      const chieuCao = form.getFieldValue(["vitalSigns", "Height"]);
      const canNang = e;
      const bmi = getBmi(chieuCao, canNang);
      form.setFieldValue(["vitalSigns", "BMI"], bmi);
    };
  }, []);
  const activeTab = useAppSelector((e) => e.common.activeTab);
  useEffect(() => {
    if (activeTab === tabKeys.NURSE_OUT.DETAIL_PATIENT) {
      getListNA();
      // getListLeDao();
    }
  }, [activeTab]);
  //lệ đạo
  const getListLeDao = async () => {
    try {
      const res = await nurseOutService.getListLeDao();
      setListLeDaoe(res);
    } catch (error) {
      Notification("error", "Đã xảy ra lỗi khi lấy danh sách lệ đạo");
    }
  };

  //nhãn áp
  const getListNA = async () => {
    try {
      const res = await nurseOutService.getListNA();
      setListNA(res);
    } catch (error) {
      setListNA(listMethodIntraocularPressure);
      // Notification("error", "Đã xảy ra lỗi khi lấy danh sách lệ đạo");
    }
  };
  return (
    <div className="nurse-info">
      <Form form={form} labelAlign="left">
        <Space direction="vertical" style={{ width: "100%" }} size={"large"}>
          <Row gutter={[16, 16]}>
            {/* <Col xl={12} md={12}> */}
            <FormList
              form={form}
              suffix="mmHg"
              name={["vitalSigns", "BloodPressure"]}
              label={"Huyết áp"}
            ></FormList>
            <FormList
              form={form}
              suffix="lần/phút"
              name={["vitalSigns", "Pulse"]}
              label={"Mạch"}
            ></FormList>

            <FormList
              form={form}
              suffix="lần/phút"
              name={["vitalSigns", "RR"]}
              label={"Nhịp thở"}
            ></FormList>
            <FormList
              form={form}
              suffix="%"
              name={["vitalSigns", "Sp02"]}
              label={"Sp02"}
            ></FormList>

            <FormList
              form={form}
              suffix="℃"
              name={["vitalSigns", "Temperature"]}
              label={"Nhiệt độ"}
            ></FormList>
            {/* </Col> */}
          </Row>
          <Row gutter={[16, 16]}>
            <InputFields data={fields}></InputFields>
          </Row>
        </Space>

        <Divider></Divider>

        <div className="name">Nhãn áp</div>

        <Row gutter={[16, 16]}>
          <Col xs={24} md={24} lg={12} xl={12}>
            <div className="title">
              <Button className="btn-sub">R/OD</Button>
            </div>
            <div className="form-list">
              <Form.List
                name={["intraocularPressure", '"intraocularPressureLeft"']}
                initialValue={[
                  {
                    mmHg: "",
                    min: null,
                    method: "",
                    comment: "",
                  },
                ]}
              >
                {(fields, { add, remove }, { errors }) => (
                  <>
                    {fields.map((field, index) => (
                      <>
                        <Row gutter={[16, 16]}>
                          <Col flex={"120px"}>
                            Kết quả{" "}
                            <span style={{ marginLeft: "4px" }}>
                              <Button
                                size="small"
                                danger={index != 0 ? true : false}
                                type="primary"
                                onClick={() => {
                                  if (index == 0) {
                                    add({
                                      mmHg: "",
                                      min: null,
                                      method: "",
                                      comment: "",
                                    });
                                  } else {
                                    remove(index);
                                  }
                                }}
                              >
                                {index == 0 ? (
                                  <Icon.add></Icon.add>
                                ) : (
                                  <Icon.sub></Icon.sub>
                                )}
                              </Button>
                            </span>
                          </Col>
                          <Col flex={"auto"}>
                            <Space>
                              <Form.Item name={[field.name, "mmHg"]}>
                                <Input
                                  addonAfter="mmHG"
                                  onChange={(e) => {
                                    setFieldValueTime([
                                      "intraocularPressure",
                                      '"intraocularPressureLeft"',
                                      field.name,
                                      "min",
                                    ]);
                                  }}
                                ></Input>
                              </Form.Item>

                              <Form.Item name={[field.name, "min"]}>
                                <Input
                                  prefix="Lúc"
                                  addonAfter={<Icon.clock />}
                                ></Input>
                              </Form.Item>
                            </Space>
                          </Col>
                        </Row>
                        <Row gutter={[16, 16]}>
                          <Col flex={"120px"}>Phương pháp</Col>
                          <Col flex={"auto"}>
                            <Form.Item name={[field.name, "method"]}>
                              <Select
                                placeholder="Chọn"
                                allowClear
                                options={listMethodIntraocularPressure}
                              />
                            </Form.Item>
                          </Col>
                        </Row>
                        <Row gutter={[16, 16]}>
                          <Col flex={"120px"}>Ghi chú</Col>
                          <Col flex={"auto"}>
                            <Form.Item name={[field.name, "comment"]}>
                              <Input allowClear placeholder="Nhập"></Input>
                            </Form.Item>
                          </Col>
                        </Row>
                      </>
                    ))}
                  </>
                )}
              </Form.List>
            </div>
          </Col>
          <Col xs={24} md={24} lg={12} xl={12}>
            <div className="title">
              <Button className="btn-sub">L/OD</Button>
            </div>
            <div className="form-list">
              <Form.List
                name={["intraocularPressure", '"intraocularPressureRight"']}
                initialValue={[
                  {
                    mmHg: "",
                    min: null,
                    method: "",
                    comment: "",
                  },
                ]}
              >
                {(fields, { add, remove }, { errors }) => (
                  <>
                    {fields.map((field, index) => (
                      <>
                        <Row gutter={[16, 16]}>
                          <Col flex={"120px"}>
                            Kết quả{" "}
                            <span style={{ marginLeft: "4px" }}>
                              <Button
                                size="small"
                                danger={index != 0 ? true : false}
                                type="primary"
                                onClick={() => {
                                  if (index == 0) {
                                    add({
                                      mmHg: "",
                                      min: null,
                                      method: "",
                                      comment: "",
                                    });
                                  } else {
                                    remove(index);
                                  }
                                }}
                              >
                                {index == 0 ? (
                                  <Icon.add></Icon.add>
                                ) : (
                                  <Icon.sub></Icon.sub>
                                )}
                              </Button>
                            </span>
                          </Col>
                          <Col flex={"auto"}>
                            <Space>
                              <Form.Item name={[field.name, "mmHg"]}>
                                <Input
                                  addonAfter="mmHG"
                                  onChange={(e) => {
                                    setFieldValueTime([
                                      "intraocularPressure",
                                      '"intraocularPressureRight"',
                                      field.name,
                                      "min",
                                    ]);
                                  }}
                                ></Input>
                              </Form.Item>

                              <Form.Item name={[field.name, "min"]}>
                                <Input
                                  prefix="Lúc"
                                  addonAfter={<Icon.clock />}
                                ></Input>
                              </Form.Item>
                            </Space>
                          </Col>
                        </Row>
                        <Row gutter={[16, 16]}>
                          <Col flex={"120px"}>Phương pháp</Col>
                          <Col flex={"auto"}>
                            <Form.Item name={[field.name, "method"]}>
                              <Select
                                placeholder="Chọn"
                                allowClear
                                options={listMethodIntraocularPressure}
                              />
                            </Form.Item>
                          </Col>
                        </Row>
                        <Row gutter={[16, 16]}>
                          <Col flex={"120px"}>Ghi chú</Col>
                          <Col flex={"auto"}>
                            <Form.Item name={[field.name, "comment"]}>
                              <Input allowClear placeholder="Nhập"></Input>
                            </Form.Item>
                          </Col>
                        </Row>
                      </>
                    ))}
                  </>
                )}
              </Form.List>
            </div>
          </Col>
        </Row>

        <Divider></Divider>

        <div className="name">Lệ đạo</div>
        <Row gutter={[16, 16]}>
          <Col xs={24} md={24} lg={12} xl={12}>
            <div className="title">
              <Button className="btn-sub">R/OD</Button>
            </div>
            <div className="form">
              <Form.Item
                label="Lệ đạo trên"
                name={["syringing", "L", "LowerPunctum"]}
                wrapperCol={{ xs: 14, md: 16, lg: 18 }}
                labelCol={{ xs: 10, md: 8, lg: 6 }}
              >
                <Select
                  placeholder="Chọn"
                  allowClear
                  options={listPunctumSyringing("dưới")}
                  // options={listLeDao.filter(e => e.type == 0)}
                ></Select>
              </Form.Item>

              <Form.Item
                label="Lệ đạo dưới"
                name={["syringing", "L", "UpperPunctum"]}
                wrapperCol={{ xs: 14, md: 16, lg: 18 }}
                labelCol={{ xs: 10, md: 8, lg: 6 }}
              >
                <Select
                  placeholder="Chọn"
                  allowClear
                  options={listPunctumSyringing("trên")}
                  // options={listLeDao.filter(e => e.type == 1)}
                ></Select>
              </Form.Item>
              <Form.Item
                label="Ghi chú"
                name={["syringing", "L", "Comment"]}
                wrapperCol={{ xs: 14, md: 16, lg: 18 }}
                labelCol={{ xs: 10, md: 8, lg: 6 }}
              >
                <Input allowClear placeholder="Nhập"></Input>
              </Form.Item>
            </div>
          </Col>
          <Col xs={24} md={24} lg={12} xl={12}>
            <div className="title">
              <Button className="btn-sub">L/OD</Button>
            </div>
            <div className="form">
              <Form.Item
                label="Lệ đạo trên"
                name={["syringing", "R", "LowerPunctum"]}
                wrapperCol={{ xs: 14, md: 16, lg: 18 }}
                labelCol={{ xs: 10, md: 8, lg: 6 }}
              >
                <Select
                  placeholder="Chọn"
                  allowClear
                  options={listPunctumSyringing("dưới")}
                  // options={listLeDao.filter((e) => e.type == 0)}
                ></Select>
              </Form.Item>

              <Form.Item
                label="Lệ đạo dưới"
                name={["syringing", "R", "UpperPunctum"]}
                wrapperCol={{ xs: 14, md: 16, lg: 18 }}
                labelCol={{ xs: 10, md: 8, lg: 6 }}
              >
                <Select
                  placeholder="Chọn"
                  allowClear
                  options={listPunctumSyringing("trên")}
                  // options={listLeDao.filter((e) => e.type == 1)}
                ></Select>
              </Form.Item>
              <Form.Item
                label="Ghi chú"
                name={["syringing", "R", "Comment"]}
                wrapperCol={{ xs: 14, md: 16, lg: 18 }}
                labelCol={{ xs: 10, md: 8, lg: 6 }}
              >
                <Input allowClear placeholder="Nhập"></Input>
              </Form.Item>
            </div>
          </Col>
        </Row>

        <Divider></Divider>

        <div className="name">Đường huyết</div>
        <Row gutter={[16, 16]}>
          <Col xs={24} md={24} lg={24} xl={24}>
            <div className="form-list">
              <Form.List
                name={["randomBloodSugar", "Result"]}
                initialValue={[{ mmHg: "0", min: null }]}
              >
                {(fields, { add, remove }, { errors }) => (
                  <>
                    {fields.map((field, index) => (
                      <>
                        <Row gutter={[16, 16]} style={{ marginTop: 8 }}>
                          <Col flex={"120px"}>
                            Kết quả{" "}
                            <span style={{ marginLeft: "4px" }}>
                              <Button
                                size="small"
                                danger={index != 0 ? true : false}
                                type="primary"
                                onClick={() => {
                                  if (index == 0) {
                                    add({
                                      mmHg: "",
                                      min: null,
                                    });
                                  } else {
                                    remove(index);
                                  }
                                }}
                              >
                                {index == 0 ? (
                                  <Icon.add></Icon.add>
                                ) : (
                                  <Icon.sub></Icon.sub>
                                )}
                              </Button>
                            </span>
                          </Col>
                          <Col flex={"auto"}>
                            <Space size={"middle"}>
                              <Form.Item name={[field.name, "mmHg"]}>
                                <Input
                                  style={{ width: "100%" }}
                                  onChange={(e) => {
                                    form.setFieldValue(
                                      [
                                        "randomBloodSugar",
                                        "Result",
                                        field.name,
                                        "min",
                                      ],
                                      formatDateToString(
                                        moment(),
                                        FORMAT_TIME.dateTime
                                      )
                                    );
                                  }}
                                  addonAfter="mmol/L"
                                  placeholder="Nhập"
                                ></Input>
                              </Form.Item>
                              {/* <span className="in">lúc</span> */}
                              <Form.Item name={[field.name, "min"]}>
                                {/* <DatePicker
                                  onChange={e => {
                                    form.setFieldValue(
                                      [field.name, "min"],
                                      formatDateToString(e)
                                    );
                                  }}
                                  showTime
                                  format={FORMAT_TIME.dateTime as string}
                                ></DatePicker> */}
                                <Input
                                  prefix="Lúc "
                                  suffix={<Icon.clock />}
                                  allowClear
                                ></Input>
                              </Form.Item>
                              <Form.Item
                                label="Ghi chú"
                                name={[field.name, "comment"]}
                                wrapperCol={{ xs: 14, md: 20, lg: 20 }}
                                labelCol={{ xs: 10, md: 4, lg: 4 }}
                              >
                                <Input allowClear placeholder="Nhập"></Input>
                              </Form.Item>
                            </Space>
                          </Col>
                        </Row>
                      </>
                    ))}
                  </>
                )}
              </Form.List>
            </div>
          </Col>
          {/* <Col xs={24} md={24} lg={12} xl={12}>
            <Form.Item
              label="Ghi chú"
              name={["randomBloodSugar", "Comments"]}
              wrapperCol={{xs: 14, md: 16, lg: 18}}
              labelCol={{xs: 10, md: 8, lg: 6}}
            >
              <Input allowClear placeholder="Nhập"></Input>
            </Form.Item>
          </Col> */}
        </Row>
      </Form>
    </div>
  );
});
export default NurseInfo;
